module.exports = "<template> <div class=tyl-button-toggle-group role=group aria-label=\"Button group\"> <slot></slot> </div> </template>";